<script>
	import {
		selectedFeature,
		activeFeature,
		activeMetric,
		tooltip,
	} from "./stores";
	import { getValues } from "./utils";
	import { getContext } from "svelte";
	import { geoPath } from "d3";
	import { geoAlbersUsa } from "d3-geo";
	import { getFeature, geoData } from "./utils";

	/**
	 * @type {
	 * 	features: [{
	 * 		geometry:	{ coordinates:[] },
	 * 		properties:	{},
	 * 	}]
	 * }
	 */
	export let geojson;
	export let mapW;
	export let mapH;

	let id;

	$: projection = geoAlbersUsa().fitSize([mapW, mapH], geojson);
	$: getPath = d => {
		return geoPath(projection)(d);
	};
	$: getFill = feature => {
		var metric = $activeMetric.id;
		var n = feature.properties[metric];
		return $activeMetric.colorScale(n);
	};

	function click(e) {
		$selectedFeature =
			$selectedFeature == $activeFeature ? getFeature() : $activeFeature;
	}

	/**
	 * @param  {document#event:mousedown} event
	 */
	function mousemove(e) {
		if (e.target.dataset.id != id) {
			id = e.target.dataset.id;
			$activeFeature = getFeature(id);

			$tooltip.text = `
				<span class="name">${$activeFeature.properties.NAME + " "}</span>
				<span class="num">${getValues($activeFeature, $activeMetric).formatted}</span>`;
		}

		// toooltip
		$tooltip.pageX = e.pageX;
		$tooltip.pageY = e.pageY;
		$tooltip.visible = true;
	}

	function mouseleave(e) {
		$activeFeature = $selectedFeature;
		$tooltip.visible = false;
		id = null;
	}
</script>

<style type="text/scss">

</style>

<svg style="width:{mapW}px;height:{mapH}px">
	<g on:click={click} on:mousemove={mousemove} on:mouseleave={mouseleave}>

		{#each geojson.features as feature}
			<path
				fill={getFill(feature)}
				data-id={feature.properties.id}
				d={getPath(feature)} />
		{/each}
		{#if $activeFeature}
			<path
				class="active"
				fill={getFill($activeFeature)}
				style="filter:url(#active)"
				data-id={$activeFeature.properties.id}
				d={getPath($activeFeature)} />
		{/if}
		{#if $selectedFeature}
			<!-- use:log={$selectedFeature} -->
			<path
				class="selected"
				fill={getFill($selectedFeature)}
				style="filter:url(#selected)"
				data-id={$selectedFeature.properties.id}
				d={getPath($selectedFeature)} />
		{/if}
	</g>
	<defs>
		<filter id="selected" height="130%">
			<!-- stdDeviation is how much to blur -->
			<feGaussianBlur in="SourceAlpha" stdDeviation="5" />
			<!-- how much to offset -->
			<feOffset dx="1" dy="3" result="offsetblur" />
			<feComponentTransfer>
				<!-- slope is the opacity of the shadow -->
				<feFuncA type="linear" slope="0.5" />
			</feComponentTransfer>
			<feMerge>
				<!-- this contains the offset blurred image -->
				<feMergeNode />
				<!-- this contains the element that the filter is applied to -->
				<feMergeNode in="SourceGraphic" />
			</feMerge>
		</filter>
		<filter id="active" height="130%">
			<!-- stdDeviation is how much to blur -->
			<feGaussianBlur in="SourceAlpha" stdDeviation="5" />
			<!-- how much to offset -->
			<feOffset dx="1" dy="3" result="offsetblur" />
			<feComponentTransfer>
				<!-- slope is the opacity of the shadow -->
				<feFuncA type="linear" slope="0.5" />
			</feComponentTransfer>
			<feMerge>
				<!-- this contains the offset blurred image -->
				<feMergeNode />
				<!-- this contains the element that the filter is applied to -->
				<feMergeNode in="SourceGraphic" />
			</feMerge>
		</filter>
	</defs>
</svg>
